import lodashDelay from 'lodash/delay';
import draggable from '@/directives/draggable.js';
import TextInput from 'components/TextInput.vue';
import LoadingSpinner from 'components/LoadingSpinner.vue';
import GridUtils from 'libs/utils.js';

export default {
  directives: {
    draggable
  },
  components: {
    'text-input': TextInput,
    'loading-spinner': LoadingSpinner
  },
  props: {
    rows: Array,
    columns: Array,
    allSelected: Boolean,
    order: String,
    filters: Array,
    multiSelect: Boolean,
    columnSearch: Boolean,
    showLoadMore: {
      type: Boolean,
      default: false
    },
    gridId: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    singleSelect: {
      type: Boolean,
      default: false
    },
    selectFirstRowOnMounted: {
      type: Boolean,
      default: false
    },
    // Emits the single-row-checked event
    emitSelectOnRow: {
      type: Boolean,
      default: false
    },
    totalResultCount: {
      type: Number,
      default: 0
    },
    gridLink: {
    },
    isHTMLGrid: {
      type: Boolean,
      default: false
    } 
  },
  data: function() {
    return {
      sortKey: '',
      isDraggingIndex: null,
      isDraggingOverIndex: null,
      orderDirection: 'ascending',
      orderedColumn: '',
      checkAllSelected: this.allSelected,
      isGrowing: false,
      innerColumns: [],
      innerRows: [],
      rowMetaData: [],
      isSelectingMultiple: false,
      toggleState: false
    };
  },
  mounted () {
    const self = this;
    window.addEventListener('mouseup', self.onMouseUp);
  },
  beforeDestroy() {
    window.removeEventListener('mouseup', self.onMouseUp);
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    titleDescrCheck: function(col) {
      if (col == null) {
        return;
      }

      if (col.Title != null && col.Title.length > 0) {
        return col.Title;
      } else {
        return col.FieldName;
      }
    },
    columnFormatter: function(entry, column) {
      return GridUtils.formatColumn(entry, column);
    }
  },
  methods: {
    execute(event, item, action) {
      if (action) {
        // prevent browser default (a href)
        event.preventDefault();
        // prevent to call click event on row
        event.stopPropagation();
        // eslint-disable-next-line
        var fn = new Function(...action);
        fn(item);
      }
    },
    onRowClick: function(event, data) {
      let row = data[0];
      let column = data[1];
      this.$emit('list-item-clicked', { event: event, obj: row, col: column });
      if (this.singleSelect) {
        let prevSelected = !this.isRowSelected(row);
        this.setCheckBoxAll(false);
        this.toggleRowSelected(row, prevSelected);
      }
    },
    onDoubleClick(event, data) {
      this.$emit('list-item-double-clicked', {
        event: event,
        row: data[0],
        col: data[1]
      });
    },
    onRowRightClick: function(event, data, type) {
      let row = null;

      if (type === 'row') {
        row = data;
      } else if (type === 'col') {
        row = data[0];
      }
      this.colCheckBoxUpdate(row, true);
      // this.$set(row, 'selected', true);
      this.$emit('list-item-clicked-right', {
        event: event,
        obj: data,
        type: type
      });
    },
    getSelectedRows() {
      const self = this;
      let results = self.innerRows.filter((x, index) => {
        let meta = self.rowMetaData[index];
        return meta.selected;
      });
      return results;
    },
    isRowSelected(entry) {
      const self = this;
      let index = self.innerRows.indexOf(entry);
      let meta = self.rowMetaData[index];
      return meta.selected;
    },
    toPixels: function(str) {
      return str + 'px';
    },
    onColumnGrow: function(event) {
      let self = this;
      this.isGrowing = true; // prevent sorting on drop
      if (event.deltaX != null) {
        var itemIndex = $(event.el).attr('holder-index');
        var selectedColumn = this.innerColumns[itemIndex];
        var newval = selectedColumn.ColumnWidth + event.deltaX;

        if (newval > 0) {
          self.$set(selectedColumn, 'ColumnWidth', newval);
        } else {
          self.$set(selectedColumn, 'ColumnWidth', 0);
        }
      }
      if (event.last) {
        lodashDelay(function() {
          self.isGrowing = false;
        }, 200);
      }
    },
    onDragStart: function(event) {
      // Fixed dragdrop: "Text" for IE 11 compatibility. Works for all browsers. "text/plain" is incorrect and only works in FF and Chrome.
      event.dataTransfer.setData('Text', '');
      this.isDraggingIndex = $(event.target).attr('holder-index');
    },
    onDrop: function(event) {
      event.preventDefault();
      event.stopPropagation();
      var dropOn = $(event.target).attr('holder-index');
      console.debug(
        'dropping from: ' + this.isDraggingIndex + ', to: ' + dropOn
      );
      this.arrayMove(this.innerColumns, this.isDraggingIndex, dropOn);
    },
    onDragOver: function(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDraggingOverIndex = $(event.target).attr('holder-index');
    },
    onDragEnd: function(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isDraggingIndex = null;
      this.isDraggingOverIndex = null;
    },
    arrayMove: function(arr, oldIndex, newIndex) {
      GridUtils.arrayMove(arr, oldIndex, newIndex);
    },
    setSortOption: function(column) {
      if (this.isGrowing || !column.IsSortable) {
        return;
      }

      if (column.FieldName !== this.orderedColumn) {
        this.orderDirection = 'ascending';
      } else {
        if (this.orderDirection === 'ascending') {
          this.orderDirection = 'descending';
        } else {
          this.orderDirection = 'ascending';
        }
      }
      this.orderedColumn = column.FieldName;
      this.$emit('order-by', {
        column: column.FieldName,
        direction: this.orderDirection
      });
    },
    isOrderingAsc: function(column) {
      return (
        this.orderedColumn === column && this.orderDirection === 'ascending'
      );
    },
    isOrderingDesc: function(column) {
      return (
        this.orderedColumn === column && this.orderDirection === 'descending'
      );
    },
    colCheckBoxUpdate: function(entry, selected, emitRowChange = false) {
      const self = this;
      let meta = self.rowMetaData.find(
        x => x.index === self.innerRows.indexOf(entry)
      );
      meta.selected = selected;
      if(emitRowChange === false){
        this.raiseSelectedChanged();
      }
      else{
        this.raiseSelectedChanged(true);
      }
    },
    toggleRowSelected: function(entry, selected) {
      this.colCheckBoxUpdate(entry, selected);
    },
    getStyleForRow: function(entry) {
      let result = {};
      if ('ComputedRowStyle' in entry && 'Styles' in entry.ComputedRowStyle) {
        result = {
          ...entry.ComputedRowStyle.Styles,
          ...result
        };
      }

      if (this.singleSelect && this.isRowSelected(entry)) {
        result = {
          'background-color': '#64B5F6',
          ...result
        };
      }
      return result;
    },
    onReturn: function(val, col) {
      col.Search = val;
      this.$emit('column-filtered', this.getColumnFilter());
    },
    advancedFilterChange () {
      let advancedFilters = this.getColumnFilterAdvanced();
      this.$emit('column-filtered-advanced', advancedFilters);
    },
    quickFilter: function(data) {
      let row = data[0];
      let col = data[1];

      let formattedData = GridUtils.getColumnStringValue(row, col);
      if (formattedData) {
        this.$set(col, 'Search', formattedData);
        this.$emit('column-filtered', this.getColumnFilter());
      }
    },
    getColumnFilterAdvanced() {
      return this.innerColumns.filter(x => x.AdvancedFilters && x.AdvancedFilters.length > 0).map(x => x.AdvancedFilters).flat();
    },
    getColumnFilter: function() {
      let filteredcols = this.innerColumns
        .filter(x => x.Search != null && x.Search.length > 0)
        .map(function(x) {
          return { FieldName: x.FieldName, Search: x.Search };
        });
      return filteredcols;
    },
    getTooltipTitle: function(col, index) {
      let el = document.querySelector('#col-title-' + index);
      if (el && el.offsetWidth < el.scrollWidth) {
        return col.Title;
      }
    },
    loadMore: function() {
      this.$emit('load-more');
    },
    resetColumnFilters: function() {
      let self = this;
      let refreshcolumnsearch = false;
      let refreshadvancedsearch = false;
      for (let col of self.innerColumns) {
        if (col.Search) {
          col.Search = '';
          refreshcolumnsearch = true;
        }
        if (col.AdvancedFilters) {
          col.AdvancedFilters = [];
          refreshadvancedsearch = true;
        }
      }
      if (refreshcolumnsearch) {
        this.$emit('column-filtered', this.getColumnFilter());
      }
      if (refreshadvancedsearch) {
        this.advancedFilterChange();
      }
    },
    setCheckBoxAll(selected) {
      for (var index in this.innerRows) {
        this.colCheckBoxUpdate(this.innerRows[index], selected);
      }
    },
    raiseSelectedChanged(data) {
      this.$emit(
        'selection-changed',
        this.rowMetaData.some(x => x.selected === true)
      );
      if (data != null && this.emitSelectOnRow) {
        this.$emit('single-row-checked');
      }
    },
    updateRows (rows, search = false) {
      this.innerRows = rows;
      this.updateSelectedRows(search);
    },
    updateSelectedRows(search) {
      /*
      Indien alles geselecteerd, bij zoeken of bijladen alles selecteren
      Anders => 
        Oorspronkelijke regels geselecteerde waarde behouden
        Nieuwe regels automatisch niet geselecteerd
      */
      const self = this;
      let allSelected = this.allSelected === true;
      
      this.rowMetaData = self.innerRows.map(x => {
        let index =  self.innerRows.indexOf(x);
        let current = this.rowMetaData[index];
        
        let selectRow = false;
        if (!search) {
          selectRow = (current ? current.selected : false); 
        }
        return {
          index: index,
          selected: current === undefined ? allSelected : selectRow
        };
      });

      if (this.selectFirstRowOnMounted) {
        if (this.rowMetaData.length) {
          this.rowMetaData[0].selected = true;
          this.$emit('selection-changed');
        }
      }
    },
    onMouseOver(entry, start = false) {
      // Is in "selecting mode" => continue selecting multiple (drag)
      if (this.isSelectingMultiple) {
        this.toggleRowSelected(entry, this.toggleState);
      }
      if (start) {
        // Start selecting. toggle state of first item determines the toggle states for the next
        this.isSelectingMultiple = true;
        this.toggleState = !this.isRowSelected(entry);
      }
    },
    onMouseUp(event) {
      // Mouse released => stop selecting multiple (drag)
      this.isSelectingMultiple = false;
    },
    getHref(row) {
      if (this.gridLink) {
        return this.gridLink(row);
      }
      return 'javascript:void(0)';
    }
  },
  computed: {
    visibleColumns () {
      return this.innerColumns ? this.innerColumns.filter(x => x.Visible) : [];
    },
    showEmptyView: function() {
      let showempty =
        (this.innerRows == null || this.innerRows.length === 0) &&
        this.isLoading === false;
      this.$log('show empty view', showempty);
      return showempty;
    },
    dataFilter: function() {
      return this.filters;
    },
    showColumnResetButton: function() {
      let show = false;
      if (
        this.columns.length > 0 &&
        this.innerColumns != null &&
        this.innerColumns.length > 0
      ) {
        let filteredcols = this.innerColumns.filter(
          x => (x.Search != null && x.Search.length > 0) || (x.AdvancedFilters && x.AdvancedFilters.length > 0)
        );

        if (filteredcols != null && filteredcols.length > 0) {
          show = true;
        }
      }
      return show;
    },
    loadMoreDivID() {
      return 'load-more-item' + this.gridId;
    }, 
    selectedCount () {
      return this.rowMetaData.filter(x => x.selected === true).length;
      // const self = this;
      // return this.innerRows.filter(x => self.rowMetaData.find(m => m.index === self.innerRows.indexOf(x)).selected === true).length;
    },
    notAllLoaded () {
      return this.innerRows.length < this.totalResultCount;
    }
  },
  watch: {
    allSelected: function() {
      this.checkAllSelected = this.allSelected;
      this.setCheckBoxAll(this.allSelected);
    },
    order: function() {
      if (this.order != null) {
        var orderProps = this.order.split(' ');
        this.orderedColumn = orderProps[0];
        this.orderDirection = orderProps[1];
      }
    },
    columns: {
      immediate: true,
      handler: function(newVal) {
        this.innerColumns = newVal;
      }
    }
  }
};
